$(window).on("load", () => {
  $(document).ready(function () {
    AOS.init({
      // offset: 0,
      // delay: 0
    });

    let oiInputs = document.querySelectorAll(
      ".ordo-input input, .ordo-select select"
    );
    oiInputs.forEach((el) => {
      el.addEventListener("focus", () => {
        el.parentElement.classList.remove(
          "ordo-input--notvalid",
          "ordo-select--notvalid"
        );
        if ($(".front-friends").length != 0) {
          if (el.getAttribute('name') != 'already-supporting') {
            document.getElementById('double-check').querySelector('input[type=checkbox]').checked = false;
          }
        }

      });
      el.addEventListener("change", () => {
        clearPaymentMethods(paymentMetod);
      });
      // turn off psae event
      el.addEventListener("paste", function (ev) {
        event.preventDefault();
        return;
      });
    });

    //price for header in bank selection
    var amountInBankSelect = document.querySelectorAll(".payment-method__amount span");

    //buttons support type single or multi
    var supportType = document.querySelectorAll(".ordo-button");
    supportType.forEach((el) => {
      var moreDataInputs = document.querySelector(".show-more-row");
      el.addEventListener("click", () => {
        //multi/single payments toogle

        if (el.id == "multi-payment") {

          el.parentElement.classList.add('toogle-on'); // toogle-swtich

          moreDataInputs.classList.add("multi-payment");
          document
            .querySelector(".info-join")
            .classList.add("info-join--active");
          document
            .querySelector("#buttons-price-wrapper")
            .classList.add("multi-payment");
          // clearInputs(inputs);
          clearPaymentMethods(paymentMetod);
          $(".show-more").slideDown("slow");
          $(".support-metod").addClass("multi-payment");
        } else {
          el.parentElement.classList.remove('toogle-on'); // toogle-swtich
          moreDataInputs.classList.remove("multi-payment");
          document
            .querySelector("#buttons-price-wrapper")
            .classList.remove("multi-payment");
          document
            .querySelector(".info-join")
            .classList.remove("info-join--active");

          // clearInputs(inputs);
          clearPaymentMethods(paymentMetod);
          $(".show-more").slideUp("slow");
          $(".support-metod").removeClass("multi-payment");
        }

        supportType.forEach(function (element) {
          element.classList.remove("button--active");
        });
        el.classList.add("button--active");
      });
    });

    // clear price inputs
    function clearInputs(arrayelements) {
      arrayelements.forEach(function (el) {
        el.classList.remove("button--active");
        el.classList.remove("button--valid");
        var input = el.querySelector("input");
        input.checked = false;
        document.querySelector(".button__inputamount").value = null;
        document.querySelector(".button__inputamount").checked = false;
      });
    }

    // clear payment methods
    function clearPaymentMethods(paymentMetod) {
      paymentMetod.forEach(function (element) {
        element.classList.remove("button--active-yellow");
      });
      $("#payment-form").empty();
      $(".payment-method").removeClass("payment-method--visible");
      $("#info_popup").removeClass("info_popup--visible");
      $("#info_popup .info_popup--infotext").remove();
      $(".payment-method").attr("data-method", "");
      if ($(".front-friends").length != 0) {
        document.getElementById('standing-order-submit').style.display = "none";
      }
    }
    /**
     * ajax form loading
     * @param bool state - set ajax status (true = ajax is loading)
     */
    function ajaxFormLoading(state) {
      oiInputs.forEach((el) => {
        if (state) {
          el.setAttribute("readonly", true);
        } else {
          el.removeAttribute("readonly");
        }
      });
    }

    // price active
    var inputsSingle = document.querySelectorAll(".button--price-single");
    inputsSingle.forEach(function (el) {
      el.addEventListener("click", () => {
        inputsSingle.forEach(function (element) {
          element.classList.remove("button--active");
          element.classList.remove("button--valid");
        });
        el.classList.add("button--active");
        amountInBankSelect.forEach((target) => {
          target.innerHTML = el.firstElementChild.value;
        });
        // set cursor to custom input element
        if (el.querySelector(".button__inputamount-single")) {
          el.querySelector(".button__inputamount-single").focus();
        }
        clearPaymentMethods(paymentMetod);
      });
    });

    var inputsMulti = document.querySelectorAll(".button--price-multi");
    inputsMulti.forEach(function (el) {
      el.addEventListener("click", () => {
        inputsMulti.forEach(function (element) {
          element.classList.remove("button--active");
          element.classList.remove("button--valid");
        });
        el.classList.add("button--active");
        amountInBankSelect.forEach((target) => {
          target.innerHTML = el.firstElementChild.value;
        });

        // set cursor to custom input element
        if (el.querySelector(".button__inputamount-multi")) {
          el.querySelector(".button__inputamount-multi").focus();
        }
        clearPaymentMethods(paymentMetod);
      });
    });

    // custom amount input
    var inputamount = document.querySelectorAll(".button__inputamount-single");
    inputamount.forEach(function (el) {
      el.addEventListener("click", () => {
        document.querySelector("#price-from-input-single").checked = true;
        input.forEach(function (element) {
          element.classList.remove("button--active");
        });
      });
      el.addEventListener("input", () => {
        var inputValue = el.value;
        document.querySelector("#price-from-input-single").value = inputValue;
        amountInBankSelect.forEach((target) => {
          target.innerHTML = el.value;
        });
        $("#payment-form").empty();
      });
    });

    var inputamount = document.querySelectorAll(".button__inputamount-multi");
    inputamount.forEach(function (el) {
      el.addEventListener("click", () => {
        document.querySelector("#price-from-input-multi").checked = true;
        inputsMulti.forEach(function (element) {
          element.classList.remove("button--active");
        });
      });
      el.addEventListener("input", () => {
        var inputValue = el.value;
        document.querySelector("#price-from-input-multi").value = inputValue;
        amountInBankSelect.forEach((target) => {
          target.innerHTML = el.value;
        });
        $("#payment-form").empty();
      });
      el.addEventListener('focusout', () => {
        if (el.value < 20) {
          console.log('focusOut less than');
          el.parentElement.classList.remove("button--active");
          el.parentElement.classList.add("button--valid");
          document.querySelector("#price-from-input-multi").checked = false;
        }
      });
    });

    //buttons payment metod
    const paymentMetod = document.querySelectorAll(".support-metod__button");
    let ajaxcalled = false;
    paymentMetod.forEach((el) => {
      // recaptchaCheck = reCaptchaInit();
      el.addEventListener("click", () => {
        clearPaymentMethods(paymentMetod);
        let multiPayment = document
          .querySelector("#multi-payment")
          .classList.contains("button--active");
        // promise!
        if (FormFieldsValidate(multiPayment) && !ajaxcalled) {
          recaptcha_ajax(grecaptchaSuccess)
            .then((grecaptchaSuccess) => {
              if (grecaptchaSuccess == "true" || grecaptchaSuccess == true) {
                //prepare AJAX
                let amountSelected;
                if (multiPayment) {
                  const price_input = document.querySelector(
                    "input[name ='amount-multi']:checked"
                  );
                  amountInBankSelect.forEach((target) => {
                    target.innerHTML = price_input.value;
                  });
                  amountSelected = $(
                    "input[name ='amount-multi']:checked"
                  ).val();
                } else {
                  const price_input = document.querySelector(
                    "input[name ='amount-single']:checked"
                  );
                  amountInBankSelect.forEach((target) => {
                    target.innerHTML = price_input.value;
                  });
                  amountSelected = $(
                    "input[name ='amount-single']:checked"
                  ).val();
                }

                ajaxcalled = true;
                paymentMetod.forEach(function (element) {
                  element.classList.remove("button--active-yellow");
                });

                el.classList.add("button--active-yellow");

                if(el.dataset.action == "tpaymobilitysoft_card"){
                  console.log( el.dataset.action);


                }



                //AJAX
                var ShortCodeAction = el.getAttribute("data-action");
                var recurrentPayment = $("#multi-payment").hasClass("button--active");

                if (ShortCodeAction == 'standing-order') {
                  $('.toggle-switch').addClass('toogle-on');
                  $('#standing-order-submit').show();
                  // $(".payment-method").removeClass("payment-method--visible");
                }
                else {
                  $('.toggle-switch').removeClass('toogle-on');

                  $('#standing-order-submit').hide();

                }


                let data_veryfication = $("input[name='data-veryfication']").is(':checked');
                const data = {
                  //data for payment
                  shortcode: ShortCodeAction,
                  amount: amountSelected,
                  name: $("input[name ='name']").val(),
                  email: $("input[name ='email']").val().toLowerCase(),
                  recurrent: recurrentPayment, //muli or single
                  action: "payment_method",
                  forminit: true,
                  //user data to save
                  person_title: $("select[name ='title']").val(),
                  last_name: $("input[name ='lname']").val(),
                  country: $("input[name ='country']").val(),
                  postcode: $("input[name ='postcode']").val(),
                  city: $("input[name ='city']").val(),
                  street: $("input[name ='street']").val(),
                  street_nr: $("input[name ='address-line1']").val(),
                  tel: $("input[name ='tel']").val(),
                  crc: $("input[name ='crc']").val(),
                  nrb: $("input[name ='nrb']").val(),
                  nrbt: $("input[name ='nrbt']").val(),
                  language: $("input[name ='lang']").val(),
                  pid: $("input[name ='pid']").val(),
                  mid: $("input[name ='mid']").val(),
                  sid: $("input[name ='sid']").val(),
                  mid_ref: $("input[name ='mid_ref']").val(),
                  url_ref: $("input[name ='url_ref']").val(),
                  uuid: $("input[name ='uuid']").val(),
                  email_ref: $("input[name ='email_ref']").val(),
                  verifierEmailStatus: $("input[name=email]").data("verifyreason"),
                  verifierEmailReason: $("input[name=email]").data("verify"),
                  ip: $("input[name=ip]").val(),
                };

                let already_supporting = false;
                if ($(".front-friends").length != 0) {
                  already_supporting = $("input[name='already-supporting']").is(':checked');
                  let kp_type = '';
                  if (already_supporting) {
                    kp_type = 'chcę się zapisać';
                  }
                  else if (ShortCodeAction == 'tpaymobilitysoft_card') {
                    kp_type = 'jestem w KP + zapis kartą';
                  }
                  else {
                    kp_type = 'zapis zleceniem stałym';
                  }
                  const additional_data = {
                    already_supporting: already_supporting,
                    kp_type: kp_type,
                    user_mail_veryfication: '',

                  }
                  Object.assign(data, additional_data);
                }


                //ajax declare
                $.ajax({
                  url: my_ajax_object.ajaxurl,
                  type: "post",
                  // contentType: "application/json",
                  // dataType: "json",
                  data: data,
                  beforeSend: function () {
                    $("#payment-method-loader").css("opacity", "1");
                    ajaxFormLoading(true);
                  },
                  success: function (response) {
                    response = JSON.parse(response);
                    console.log("api sucess");
                    let method = $(".button--active-yellow").attr(
                      "data-action"
                    );
                    if (response.email_return_url != false) {
                      window.location.replace(response.email_return_url);
                      // delete_cookie('post_id', '', window.location.hostname);
                    }
                    if (!already_supporting) {
                      $(".payment-method").addClass("payment-method--visible");
                    }
                    if (ShortCodeAction == 'standing-order') {
                      // $(".payment-method").removeClass("payment-method--visible");
                    }

                    $("#payment-form").empty().append(response.content);

                    $(".payment-method").attr("data-method", method);
                    // if(!already_supporting){
                    //   scrollToEl($(".payment-method"));
                    // }
                    // else{
                    //   scrollToEl($("#email_status"), 200);
                    // }

                    // grecaptcha.reset();

                  },
                  error: function (response) {
                    console.log("api error");
                    $(".payment-method").removeClass("payment-method--visible");
                    $("#payment-form")
                      .empty()
                      .append(
                        '<h3 class="text-center">' + tpay_error.innerHTML + '</h3>'
                      );
                  },
                  complete: function () {
                    ajaxcalled = false;
                    $("#payment-method-loader").css("opacity", "0");
                    ajaxFormLoading(false);
                  },
                });
              } else {
                console.log("grecaptcha user suspicion");
              }
            })
            .catch((err) => {
              console.log("catch error: " + err);
            });
        } else {
          $("#payment-form").empty();
          console.log("form not valid");
        }
      });
    });

    // show more form fields
    $("#show-more").on("click", function () {
      $(".show-more").slideToggle("slow");
    });

    // js Validate
    /**
     *
     * @param bool paymenttype (check its single or multipayment)
     */
    function FormFieldsValidate(paymenttype) {
      let inputFilled = false;

      // var title = $("select[name ='title']");
      var iname = $("input[name ='name']");
      var mail = $("input[name ='email']");

      var country = $("input[name ='country']");
      var lname = $("input[name ='lname']");
      var postcode = $("input[name ='postcode']");
      var city = $("input[name ='city']");
      var streetAddress = $("input[name ='street']");
      var addressLine1 = $("input[name ='address-line1']");
      var tel = $("input[name ='tel']");
      var data_veryfication = $("input[name='data-veryfication']");
      let already_supporting = $('input[name="already-supporting"]');
      //multiple payment valid
      if (paymenttype) {
        var amount = $("input[name ='amount-multi']:checked");
        if (amount.val() == "" || typeof amount.val() === "undefined") {
          $(".button--price").addClass("button--valid");
          scrollToEl($("#buttons-price-wrapper"));
        }

        // else if (title.val() == "" || typeof title.val() === "undefined" || title.val() == '--') {
        //   title.parent().addClass("ordo-select--notvalid");
        //   scrollToEl(title);
        // }

        else if (iname.val() == "") {
          iname.parent().addClass("ordo-input--notvalid");
          scrollToEl(iname);
        } else if (!isEmail(mail.val())) {
          mail.parent().addClass("ordo-input--notvalid");
          scrollToEl(mail);
        } else if (lname.val() == "") {
          lname.parent().addClass("ordo-input--notvalid");
          scrollToEl(lname);
        } else if (country.val() == "") {
          country.parent().addClass("ordo-input--notvalid");
          scrollToEl(country);
        } else if (postcode.val() == "") {
          postcode.parent().addClass("ordo-input--notvalid");
          scrollToEl(postcode);
        } else if (city.val() == "") {
          city.parent().addClass("ordo-input--notvalid");
          scrollToEl(city);
        } else if (streetAddress.val() == "") {
          streetAddress.parent().addClass("ordo-input--notvalid");
          scrollToEl(streetAddress);
        } else if (addressLine1.val() == "") {
          addressLine1.parent().addClass("ordo-input--notvalid");
          scrollToEl(addressLine1);
        } else if (
          tel.val() == "" ||
          tel.attr("minlength") > tel.val().length
        ) {
          tel.parent().addClass("ordo-input--notvalid");
          scrollToEl(tel);
        }
        else if ($(".front-friends").length != 0 && data_veryfication.is(':checked') == false) {
          data_veryfication.parent().addClass("ordo-input--notvalid");
          scrollToEl(data_veryfication);
        }
        //is valid
        else if (
          iname.val() !== "" &&
          isEmail(mail.val()) &&
          amount.val() !== "" &&
          amount.val() !== 0 &&
          // title.val() !== 0 &&
          // title.val() !== "" &&
          // title.val() !== "--" &&
          typeof amount.val() !== "undefined" &&
          lname.val() !== "" &&
          country.val() !== "" &&
          postcode.val() !== "" &&
          city.val() !== "" &&
          streetAddress.val() !== "" &&
          tel.val() !== "" &&
          tel.val().length >= tel.attr("minlength")
        ) {
          inputFilled = true;
          // inputFilled = {'amount': amount.val(),'name': iname.val(),'emaiil': mail.val()} ;
        }
        if (!inputFilled && $(".front-friends").length != 0) {
          document.getElementById('double-check').querySelector('input[type=checkbox]').checked = false;

        }

        return inputFilled;
      }
      //single payment valid
      else {
        var amount = $("input[name ='amount-single']:checked");
        if (amount.val() == "" || typeof amount.val() === "undefined") {
          $(".button--price").addClass("button--valid");
          scrollToEl($(".button--price"));
        }

        // else if (title.val() == "" || typeof title.val() === "undefined" || title.val() == '--') {
        //   title.parent().addClass("ordo-select--notvalid");
        //   scrollToEl(title);
        // }
        else if (iname.val() == "") {
          iname.parent().addClass("ordo-input--notvalid");
          scrollToEl(iname);
        } else if (!isEmail(mail.val())) {
          mail.parent().addClass("ordo-input--notvalid");
          scrollToEl(mail);
        }
        //is valid
        else if (
          iname.val() !== "" &&
          isEmail(mail.val()) &&
          amount.val() !== "" &&
          amount.val() !== 0 &&
          // title.val() !== 0 &&
          // title.val() !== "" &&
          // title.val() !== "--" &&
          typeof amount.val() !== "undefined"
        ) {
          inputFilled = true;
          // inputFilled = {'amount': amount.val(),'name': iname.val(),'emaiil': mail.val()} ;
        }

        return inputFilled;
      }
    }
    //Email input veryfier
    var emailToVeryfier = document.querySelector("input[name=email]");

    // emailToVeryfier.addEventListener("change", () => {
    //   verifierEmailByApi(emailToVeryfier.value, true);
    // });

    function isEmail(email) {
      var regex =
        /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return regex.test(email);
    }
    function verifierEmailByApi(email, asynch = false) {
      let emailExist = false;

      if (isEmail(email)) {
        //AJAX RAPID Email Verifier
        $.ajax({
          url: my_ajax_object.ajaxurl,
          type: "post",
          async: asynch,
          dataType: "JSON",
          data: {
            action: "email_verifier",
            email: email,
          },
        }).done(function (respond) {
          if (respond["status"] == "valid") {
            emailExist = true;
            emailToVeryfier.dataset.verify = respond["status"];
            emailToVeryfier.dataset.verifyreason = respond["reason"];
          } else {
            emailExist = false;
            // const mail = $("input[name ='email']");
            // mail.parent().addClass("ordo-input--notvalid");
            // scrollToEl(mail);
            emailToVeryfier.dataset.verify = false;
            emailToVeryfier.dataset.verifyreason = respond["reason"];
          }
        });
        // return emailExist;
      } else {
        return false;
      }
    }

    function scrollToEl(element, offset = 200) {
      $("html, body").animate(
        { scrollTop: element.offset().top - offset },
        "slow"
      );
    }

    //Show GDPR popup and Hide GDPRtitle
    var showGdpr = document.querySelector("#show-gdpr");
    var closeGdpr = document.querySelectorAll(".popup-page__close");
    var popup = document.querySelector(".popup-page");
    // var showFriendsInfo = document.querySelector(".popup-page");
    showGdpr.addEventListener("click", () => {
      popup.classList.add("popup-page--active");
      scrollToEl($('.supportus-container'));
      // document.body.scrollTop = 0;
      // document.documentElement.scrollTop = 0;
    });
    closeGdpr.forEach((el) => {
      el.addEventListener("click", () => {
        popup.classList.remove("popup-page--active");
        popup.classList.remove("popup-page--active-friends");
      });
    });
    let friendsWrapper = document.querySelector(".friends-info");

    document.querySelector(".info-join").addEventListener("click", () => {
      popup.classList.add("popup-page--active-friends");
    });

    // Allow spaces in input[type=text]
    $("input[type=text]").keyup(function (event) {
      if (event.keyCode == 32) {
        $(this).val($(this).val() + " ");
      }
    });

    function toogle_lang_switcher() {
      $("#flags_language_selector").on("click", function () {
        $(this).toggleClass("langs-wrapper--active");
      });
    }
    toogle_lang_switcher();




    /**
     * PAGE FRIENDS
     */
    if ($(".front-friends").length != 0) {
      // double check popup
      $('#double-check').on('click', function () {
        event.preventDefault();
        show();
      });
      $('#already-supporting').on('click', function () {
        // event.preventDefault();
        let already_supporting_checkbox = $('input[name="already-supporting"]');
        $('#standing-order-submit').hide();
        if (already_supporting_checkbox.is(':checked')) {
          $('#form-finish').hide();
          $('#form-finish-second').show();
          const price_input = document.querySelector(
            "input[name ='amount-multi']:checked"
          );
          amountInBankSelect.forEach((target) => {
            target.innerHTML = price_input.value;
          });
        }
        else {
          $('#form-finish').show();
          $('#form-finish-second').hide();

        }
      });


      const element = document.getElementById("popup-double-check");
      let user_data_wrapper = element.querySelector('.user-data');
      const show = () => {

        element.style.visibility = "visible";
        element.style.opacity = "1";
        document.querySelector('main').style.filter = "blur(3px)";
        document.querySelector('section.footer').style.filter = "blur(3px)";

        // element.style.transform = "scale(1)";
        element.style.transition = "0.4s, opacity 0.4s";
        let person_title = $("select[name ='title']");
        var amount = $("input[name ='amount-multi']:checked").val();
        if (!amount) {
          amount = '';
        }
        var iname = $("input[name ='name']");
        var mail = $("input[name ='email']");
        var country = $("input[name ='country']");
        var lname = $("input[name ='lname']");
        var postcode = $("input[name ='postcode']");
        var city = $("input[name ='city']");
        var streetAddress = $("input[name ='street']");
        var addressLine1 = $("input[name ='address-line1']");
        var tel = $("input[name ='tel']");
        let user_data =
          '<h3>Kwota:</h3>' +
          '<p class="ttc">' + amount + '</p>' +
          '<h3>' + person_title.parent('.ordo-select').find('.field-text').text() + ':</h3>' +
          '<p class="ttc">' + person_title.val() + '</p>' +
          '<h3>' + iname.parent('.ordo-input').find('.field-text').text() + ':</h3>' +
          '<p class="ttc">' + iname.val() + '</p>' +
          '<h3>' + mail.parent('.ordo-input').find('.field-text').text() + ':</h3>' +
          '<p>' + mail.val() + '</p>' +
          '<h3>' + country.parent('.ordo-input').find('.field-text').text() + ':</h3>' +
          '<p class="ttc">' + country.val() + '</p>' +
          '<h3>' + lname.parent('.ordo-input').find('.field-text').text() + ':</h3>' +
          '<p class="ttc">' + lname.val() + '</p>' +
          '<h3>' + postcode.parent('.ordo-input').find('.field-text').text() + ':</h3>' +
          '<p>' + postcode.val() + '</p>' +
          '<h3>' + city.parent('.ordo-input').find('.field-text').text() + ':</h3>' +
          '<p class="ttc">' + city.val() + '</p>' +
          '<h3>' + streetAddress.parent('.ordo-input').find('.field-text').text() + ':</h3>' +
          '<p class="ttc">' + streetAddress.val() + '</p>' +
          '<h3>' + addressLine1.parent('.ordo-input').find('.field-text').text() + ':</h3>' +
          '<p>' + addressLine1.val() + '</p>' +
          '<h3>' + tel.parent('.ordo-input').find('.field-text').text() + ':</h3>' +
          '<p>' + tel.val() + '</p>';

        user_data_wrapper.innerHTML = "";
        user_data_wrapper.innerHTML = user_data;
      };

      const hide = () => {
        const element = document.querySelector("#popup-double-check");
        document.querySelector('main').style.filter = "none";
        document.querySelector('section.footer').style.filter = "none";
        element.style.visibility = "hidden";
        element.style.opacity = "0";
        // element.style.transform = "scale(0.5)";
        element.style.transition = "0.2s, opacity 0.2s, visibility 0s 0.2s";
      };

      document.onkeydown = (event) => {
        event = event || window.event;
        if (event.keyCode === 27) {
          hide();
        }
      };
      // });
      element.querySelectorAll('.user-data-answear').forEach((el) => {
        el.addEventListener("click", () => {
          let checkbox = document.getElementById('double-check').querySelector('input[type=checkbox]');
          if (el.dataset.answear == 'yes') {
            checkbox.checked = true;
          }
          else {
            checkbox.checked = false;
          }
          hide();
        });
      });
    }
    function navigationBurger() {
      //Toggle burger menu
      const burger = $(".burger");
      const menuWrapper = $(".menu__wrapper");

      burger.on("click", function () {
        $(this).toggleClass("active");
        $(this).toggleClass("not-active");
        $(menuWrapper).toggle("slow");
      });
    }
    navigationBurger();

    function delete_cookie(name, path, domain) {
      if (get_cookie(name)) {
        console.log('delete');
        document.cookie = name + "=" +
          ((path) ? ";path=" + path : "") +
          ((domain) ? ";domain=" + domain : "") +
          ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
      }
    }
    function get_cookie(name) {
      return document.cookie.split(';').some(c => {
        return c.trim().startsWith(name + '=');
      });
    }

    if ($(".front-friends").length != 0) {

      function custom_anchors() {
        let anchors = document.querySelectorAll('.menu-anchor');
        anchors.forEach((el) => {
          el.addEventListener('click', () => {
            event.preventDefault();
            scrollToEl($(el.getAttribute('href')), 100);
          });
        })
      }
      custom_anchors();

      $('.quote-slides').owlCarousel(
        {
          // navigation: false,
          dots: true,
          slideSpeed: 300,
          paginationSpeed: 400,
          items: 1,
          autoPlay: true,
          loop: true,
          nav: false,
        }
      );

      $('.gallery-slides').owlCarousel(
        {
          // navigation: true,
          dots: false,
          slideSpeed: 300,
          paginationSpeed: 400,
          items: 3,
          autoPlay: true,
          loop: true,
          nav: true,
          responsive:{
            0:{
                items:1,
            },
            768:{
                items:3,
            },

        }
          // nav: false,
        }
      );

    }

    $(document).trigger("scroll");
  $("#idRedirectWspieram").click(function() {

        var person_title = encodeURIComponent($("select[name ='title']").val());
        var firstname = encodeURIComponent($("input[name ='name']").val());
        var email = encodeURIComponent($("input[name ='email']").val());
        var lastname = encodeURIComponent($("input[name ='lname']").val());
        var country = encodeURIComponent($("input[name ='country']").val());
        var postcode = encodeURIComponent($("input[name ='postcode']").val());
        var post = encodeURIComponent($("input[name ='city']").val());
        var line_address_1 = encodeURIComponent($("input[name ='street']").val());
        var line_address_2 = encodeURIComponent($("input[name ='address-line1']").val());
        var phone = encodeURIComponent($("input[name ='tel']").val());
	var mid_ref= encodeURIComponent($("input[name ='mid_ref']").val());

        var r0 = $(".button--price.button--price-multi > input.button__selectamount").eq(5).val(); // 6 przycisk sterowany parametrem r0
        var r1 = $(".button--price.button--price-multi > input.button__selectamount").eq(0).val();
        var r2 = $(".button--price.button--price-multi > input.button__selectamount").eq(1).val();
        var r3 = $(".button--price.button--price-multi > input.button__selectamount").eq(2).val();
        var r4 = $(".button--price.button--price-multi > input.button__selectamount").eq(3).val();
        var r5 = $(".button--price.button--price-multi > input.button__selectamount").eq(4).val();

        function getSelectedPriceButtonNr() {
          var result = 2;

          $("label.button--price.button--price-multi").each(function(index) {
            if($(this).is(".button--active, .button--valid"))
              result = (index + 1) % 6; // 1 przycisk jest sterowany parametrem r1, a 6 przycisk parametrem r0
          });

          return result;
        }

        var selr = getSelectedPriceButtonNr();

        window.location.href = "https://wspieram.ordoiuris.pl/?tp=2" + "&firstname=" + firstname +
                                                                       "&email=" + email +
                                                                       "&lastname=" + lastname +
                                                                       "&person_title=" + person_title +
                                                                       "&country=" + country +
                                                                       "&postcode=" + postcode +
                                                                       "&post=" + post +
                                                                       "&line_address_1=" + line_address_1 +
                                                                       "&line_address_2=" + line_address_2 +
                                                                       "&phone=" + phone +
                                                                       "&r0=" + ((r0 < 20) ? "" : r0) +
                                                                       "&r1=" + r1 +
                                                                       "&r2=" + r2 +
                                                                       "&r3=" + r3 +
                                                                       "&r4=" + r4 +
                                                                       "&r5=" + r5 +
                                                                       "&selr=" + selr +
								       "&mid_ref=" + mid_ref;
    });
  }); //document ready

  // JS friends template
  $(document).scroll(function () {


    if ($(".front-friends").length != 0) {
      let windowHeight = $(window).height();
      let windowScroll = $(window).scrollTop();
      let constPicture = 190;
      // let tempHeight = windowHeight - 218 - constPicture;

      if (windowScroll > 0) {
        $(".front .menu").addClass("stickyTop");
      } else {
        $(".front .menu").removeClass("stickyTop");
      }
      //Counters
      if (windowScroll + windowHeight >= $("#statistics").position().top) {
        $(".count").each(function () {
          $(this)
            .prop("Counter", 0)
            .animate(
              {
                Counter: $(this).attr("value"),
              },
              {
                duration: 2000,
                easing: "swing",
                step: function (now) {
                  $(this).text(Math.ceil(now));
                },
              }
            );
        });
      }

    }
  });


});
